import { render, staticRenderFns } from "./ResendInvitation.vue?vue&type=template&id=0c78e7ca&"
import script from "./ResendInvitation.vue?vue&type=script&lang=js&"
export * from "./ResendInvitation.vue?vue&type=script&lang=js&"
import style0 from "./ResendInvitation.vue?vue&type=style&index=0&id=0c78e7ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports